// Copyright 2025. WebPros International GmbH. All rights reserved.

import { RootState as AdminRootState } from 'admin/core/store';
import { RootState as ClientRootState } from 'client/core/store';
import { FEATURES } from 'common/modules/app/features/constants';

export const isFeatureFlagEnabled = (state: AdminRootState | ClientRootState, feature: FEATURES | string | undefined) =>
    feature === undefined || state?.app?.features?.has(feature) || state?.settings?.enabled_feature_flags?.includes(feature);
